<template>
    <div class="land-news">
        <div class="container">
            <div class="land-news-container-info">
                <div class="section-title">
                    <h2>{{salesCard.project_shablon_fields.news_section_title}}</h2>
                </div>
                <div class="land-news-items">
                    <div class="item" v-for="(item, index) in salesCard.project_shablon_fields.news_items" :key="index">
                        <div class="item-title">
                            <h3>{{item.title}}</h3>
                        </div>
                        <div class="item-ready">
                            <div class="ready-scale">
                                <div class="default-line"></div>
                                <div class="ready-line" :style="'width:' + item.ready_number + '%'"></div>
                            </div>
                            <div class="item-ready-number" :style="'left:' + item.ready_number + '%'">
                                <h4>
                                    {{item.ready_number}}
                                </h4>
                                <span>%</span>
                            </div>
                        </div>
                        <a href="#" class="land-news-link" :disabled="item.btn_activity == false"  @click.prevent="openNewsModalInit(index)" v-if="!isMobileChecker"><span v-if="globalLang != 'kz/'">Подробнее</span><span v-else>Толығырақ</span></a>
                        <a href="#" class="land-news-link-mobile" :disabled="item.btn_activity == false"  @click.prevent="openNewsModalInit(index)" v-if="isMobileChecker"><svgIcon name="arrow-right-news" /></a>
                    </div>
                </div>
            </div>
            <!-- Новостная модалка -->
            <modal name="news-modal" 
                @before-close="beforeNewsModalClose" 
                @closed="newsModalClosed" 
                :transition="transitionName" 
                :width="modalWidth" 
                :height="modalHeight" 
                :scrollable="modalScrollable"                 
                id="news-modal">
                <newsModal :config="[{loading: loading, notVisible: notVisible, visible: visible}]"></newsModal>
            </modal>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import newsModal from '@/components/sales-land-partials/land-news-modal.vue'
    export default {
        name: 'sale-land-news',
        components: {
            newsModal,
            svgIcon,
        },
        data () {
            return {
                get: [
                    {
                        link: window.host + '_one'
                    },
                    {
                        link: window.host + '_two'
                    },
                    {
                        link: window.host + '_three'
                    },
                    {
                        link: window.host + '_four'
                    },
                    {
                        link: window.host + '_five'
                    },
                ],
                getAltynBesik: [
                    {
                        link: 'altyn_besik' + '_one'
                    },
                    {
                        link: 'altyn_besik' + '_two'
                    },
                    {
                        link: 'altyn_besik' + '_three'
                    },
                ],
                getSoho: [
                    {
                        link: 'soho' + '_one'
                    },
                    {
                        link: 'soho' + '_two'
                    },
                    {
                        link: 'soho' + '_three'
                    },
                ],
                getMonaco: [
                    {
                        link: 'monaco_news_part' + '_one'
                    },
                    {
                        link: 'monaco_news_part' + '_two'
                    },
                    {
                        link: 'monaco_part' + '_three'
                    },
                ],
                getOrion: [
                    {
                        link: 'orion_iii' + '_one'
                    }
                ],
                getNurlyDala2: [
                    {
                        link: 'nurly_dala2_one'
                    },
                    {
                        link: 'nurly_dala2_two'
                    },
                    {
                        link: 'nurly_dala2_three'
                    },
                ],
                getRivieraPlus: [
                    {
                        link: 'rivieraplus_one'
                    },
                    {
                        link: 'rivieraplus_two'
                    },
                    {
                        link: 'rivieraplus_three'
                    },
                ],
                ready: [
                    {
                        number: 0
                    },
                    {
                        number: 0
                    },
                    {
                        number: 0
                    }
                ],
                visible: false,
                activity: [],
                loading: true,
                notVisible: true,
                animate: false,
                modalWidth: 1000,
                modalHeight: 'auto',
                modalScrollable: false,
                transitionName: 'pop-out',
                projectHost: window.host,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            openNewsModalInit(index) {
                var _self = this;
                var url;
                if (this.projectHost == 'altyn-besik') {
                    url = window.newsUrl + window.GlobalLang + window.JsonUrl + this.getAltynBesik[index].link;
                } else if (this.projectHost == 'soho2') {
                    url = window.newsUrl + window.GlobalLang + window.JsonUrl + this.getSoho[index].link;
                } else if (this.projectHost == 'monaco') {
                    url = window.newsUrl + window.GlobalLang + window.JsonUrl + this.getMonaco[index].link;
                } else if (this.projectHost == 'orion-3') {
                    url = window.newsUrl + window.GlobalLang + window.JsonUrl + this.getOrion[index].link;
                } else if (this.projectHost == 'nurly-dala2') { 
                    url = window.newsUrl + window.GlobalLang + window.JsonUrl + this.getNurlyDala2[index].link;
                } else if (this.projectHost == 'riviera-plus') {
                    url = window.newsUrl + window.GlobalLang + window.JsonUrl + this.getRivieraPlus[index].link;
                } else {
                    url = window.newsUrl + window.GlobalLang + window.JsonUrl + this.get[index].link;
                }
                // console.log(url)
                axios.get(url).then((response) => {
                    // console.log(url, response)
                    if(response)
                        this.$store.dispatch('clearNewsData');
                        var i;
                        for (i = 0; i < response.data.length; i++) {
                            this.$store.commit('newsData', response.data[i].acf);
                        }
                        _self.notVisible = false;
                        _self.loading = false;
                        this.visible = true;
                });

                this.$modal.show('news-modal');
                window.body.addClass('overflowTrue');
                document.getElementById('header').classList.add('notvisible');
                document.getElementById('dropdown-menu-project').classList.add('notvisible');
                document.getElementById('footer').classList.add('notvisible');
                // document.getElementById('secret-btns').classList.remove('fadeIn');
            },
            beforeNewsModalClose() {
                this.notVisible = true;
            },
            newsModalClosed() {
                this.loading = true;
                this.valueOption = 0;
				window.body.removeClass('overflowTrue');
                document.getElementById('header').classList.remove('notvisible');
                document.getElementById('dropdown-menu-project').classList.remove('notvisible');
                document.getElementById('footer').classList.remove('notvisible');
                // document.getElementById('secret-btns').classList.add('fadeIn');
            },
            settingsNewsModal() {
				var _self = this;
				if ($(window).width() > 1024) {
					_self.modalWidth = 1000;
					_self.modalHeight = 'auto';
					_self.transitionName = 'pop-out';
				} else {
					_self.modalWidth = 100;
					_self.modalHeight = 'auto';
					_self.modalScroll = true;
					_self.transitionName = 'fade-enter';
				}
			},
			handleResize() {
                var _self = this;
                if (window.innerWidth >= 1024) {
                    _self.modalWidth = 1000;
					_self.modalHeight = 'auto';
                } else {
					_self.modalScroll = true;
					_self.modalHeight = 'auto';
				}
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.settingsNewsModal();
            this.checkResize();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-news.scss';
    @import '@/styles/components/sales/respond/land-news-respond.scss';
    //  @import '@/styles/respond/sales/sales-land-partials/land-news-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>